import { type TradeInAemNavActionsType, TRADE_IN_AEM_NAV_SET_STEP } from "../actions/TradeInAemNavActions";
import { TradeInAemNavStep } from "../../utils/constants";

export type TradeInAemNavReducerType = {
    step: TradeInAemNavStep;
};

export const initialStateTradeInAemNav: TradeInAemNavReducerType = {
    step: TradeInAemNavStep.FindVehicle,
};

const TradeInAemNavReducer = (
    state: TradeInAemNavReducerType = initialStateTradeInAemNav,
    action: TradeInAemNavActionsType,
): TradeInAemNavReducerType => {
    switch (action.type) {
        case TRADE_IN_AEM_NAV_SET_STEP: {
            const { step } = action;
            return { ...state, step };
        }

        default:
            return state;
    }
};

export default TradeInAemNavReducer;
